import { Component, HostBinding, Input } from '@angular/core'; 
import { BRAND } from 'src/app/shared/brand';
import { CultureService } from '../../culture/culture.service';

export interface SocialLinksItem {
    type: string;
    url: string;
    icon: string;
}

export type SocialLinksShape = 'circle' | 'rounded';

@Component({
    selector: 'app-social-links',
    templateUrl: './social-links.component.html',
    styleUrls: ['./social-links.component.scss']
})
export class SocialLinksComponent 
{ 
    /// TODO(operator): PrimeHat's own profiles, e.g. {type: 'facebook', url: '...', icon: 'facebook-f'}. None yet, so none
    /// is linked.
    items: SocialLinksItem[] = [];

    /// The tooltip and the accessible name: each link is only an icon.
    readonly names: Record<string, string> = {
        facebook: this.culture.t('social-brand-on-facebook', '{brand} on Facebook', { brand: BRAND.name }),
        x: this.culture.t('social-brand-on-x', '{brand} on X', { brand: BRAND.name }),
        youtube: this.culture.t('social-brand-on-youtube', '{brand} on YouTube', { brand: BRAND.name }),
        instagram: this.culture.t('social-brand-on-instagram', '{brand} on Instagram', { brand: BRAND.name }),
        tiktok: this.culture.t('social-brand-on-tiktok', '{brand} on TikTok', { brand: BRAND.name }),
        rss: this.culture.t('social-brand-news-feed', '{brand} news feed', { brand: BRAND.name }),
    };

    @Input() shape: SocialLinksShape;

    @HostBinding('class.social-links') classSocialLinks = true;

    @HostBinding('class.social-links--shape--circle') get classSocialLinksShapeCircle(): boolean { return this.shape === 'circle'; }

    @HostBinding('class.social-links--shape--rounded') get classSocialLinksShapeRounded(): boolean { return this.shape === 'rounded'; }

    constructor(private culture: CultureService) { }
}
